import getValueFees from 'core/controllerPlans/getValueFees'
import isEpicPlan from 'utils/pivot/plan/isEpicPlan'
import moneyFormat from 'utils/format/money'
import isFixedPlan from 'utils/pivot/plan/isFixedPlan'
import { propAccessor } from '@hc-frontend/utils'
import getUrlParams from 'utils/DOM/getURLParams'

export function getFixedTooltip({ baseRate, applicationFee }) {
  return `Includes base premium of ${moneyFormat(baseRate)} and 
    ${moneyFormat(applicationFee)} Administration fee which includes services for member 
    advocacy and navigation, bill negotiation and mobile app
  `
}

export function getSTMTooltip({ baseRate, hiTax, administrativeFee, association }) {
  let message = `Includes ${moneyFormat(baseRate)} base premium`
  if (hiTax) {
    message += ' and 3.5% federal health insurance tax'
  }

  message += ` and ${moneyFormat(administrativeFee)} in administrative fees`

  if (association) {
    message += ' and association dues'
  }

  return message
}

export function getEpicTooltip({ baseRate, administrativeFee, association }) {
  const base = `Includes ${moneyFormat(baseRate)} insurance premium and ${moneyFormat(
    administrativeFee
  )} `

  return base + (association ? 'association dues.' : 'non-insured health benefits fees')
}

export function tooltipMessage(state, plan, durationDetails) {
  const { policies: policiesFromParams, period: periodFromParams } = getUrlParams() || {}
  const policies = propAccessor(state, 'filters.policies') || policiesFromParams
  const typeOfPay = state.typeOfPay || 'monthly'
  const payDetails = durationDetails || plan.durations[state.period === 'undefined' ? periodFromParams : state.period][policies][typeOfPay]

  const association = getValueFees('Association Fee', payDetails.fees)

  const hiTax = payDetails.taxes.find(tax => tax.name === 'HiTax')

  const baseRate = payDetails.baseRate + (hiTax ? hiTax.value : 0)

  const administrativeFee = payDetails.fees
    .filter(fee => fee.name !== 'Application Fee')
    .reduce((acc, fee) => acc + fee.value, 0)

  if (administrativeFee === 0) {
    return ''
  }

  if (isEpicPlan(plan)) {
    return getEpicTooltip({ baseRate, administrativeFee, association })
  }

  if (isFixedPlan(plan)) {
    const ppoFee = getValueFees('Ppo Fee', payDetails.fees, 0)
    const telemedicineFee = getValueFees('Telemed Fee', payDetails.fees, 0)
    const applicationFee = getValueFees('Application Fee', payDetails.fees, 0)
    const newBaseRate = baseRate + ppoFee + telemedicineFee

    return getFixedTooltip({ baseRate: newBaseRate, applicationFee })
  }

  return getSTMTooltip({ baseRate, hiTax, administrativeFee, association })
}

export default tooltipMessage
